// extracted by mini-css-extract-plugin
module.exports = {"Container":"Home_Container__39yWl","Selector":"Home_Selector__hzhOr","Services":"Home_Services__tvOQS","Loading":"Home_Loading__2vmZ4","NoServices":"Home_NoServices__2mcRk"};